import PropTypes from "prop-types";
import "./IconRing.scss"

const IconRing = ({
  src,
  alt = "Icon Ring",
  iconSize = 16,
  padding = 10,
  ring = 1,
  color = "#DDD",
}) => (
  <span
    className="icon-ring-circle"
    style={{
      width: iconSize,
      height: iconSize,
      padding,
      border: `${ring}px solid ${color}`,
      borderRadius: "50%",
      boxSizing: "content-box",
    }}
  >
    <img className="icon-ring-image" src={src} alt={alt} />
  </span>
);

IconRing.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  iconSize: PropTypes.number,
  padding: PropTypes.number,
  ring: PropTypes.number,
  color: PropTypes.string,
};

export default IconRing;